import React, { useState } from "react";
import { Box, Typography, Paper, Avatar, Button, Grid } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import BackspaceIcon from "@mui/icons-material/Backspace";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../Dashboard/DashboardHeader";

export default function ReviewTransaction() {
  const [pin, setPin] = useState("");

  const handlePress = (num) => {
    if (pin.length < 4) setPin(pin + num);
  };

  const handleDelete = () => {
    setPin(pin.slice(0, -1));
  };
  const navigate = useNavigate();
  const transactionstatus = () => {
    navigate("/dashboard/transfertobank/addbeneficiary/transactionstatus");
  };

  return (
    <>
      <DashboardHeader />

      <Box bgcolor="#f6fafc" minHeight="100vh">
        <Box
          sx={{
            maxWidth: "1050px",
            mx: "auto",
            py: 5,
            px: 3,
          }}
        >
          <Typography
            fontSize={13}
            color="text.secondary"
            mb={2}
            sx={{ cursor: "pointer", fontWeight: 500 }}
            onClick={() => navigate("/dashboard/transfertobank/addbeneficiary/transferamount")}
          >
            ← EDIT DETAILS
          </Typography>

          <Typography variant="h5" fontWeight="bold" mb={4}>
            Review Transaction
          </Typography>

          <Grid container spacing={4}>
            {/* Left Summary */}
            <Grid size={{ xs: 12, md: 5 }} item xs={12} md={5}>
              <Paper sx={{ p: 3, borderRadius: 3 }}>
                <Box display="flex" gap={2} mb={3}>
                  <Avatar sx={{ bgcolor: "#eef2f7" }}>R</Avatar>
                  <Box>
                    <Typography fontWeight="bold">Rahul Sharma</Typography>
                    <Typography fontSize={13} color="text.secondary">
                      HDFC Bank
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography color="text.secondary">
                    Transfer Amount
                  </Typography>
                  <Typography>₹1500.00</Typography>
                </Box>

                <Box display="flex" justifyContent="space-between" mb={3}>
                  <Typography color="text.secondary">
                    Processing Charges
                  </Typography>
                  <Typography>₹5.90</Typography>
                </Box>

                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography fontWeight="bold">Total Payable</Typography>
                  <Typography fontWeight="bold" color="success.main">
                    ₹1505.90
                  </Typography>
                </Box>

                <Typography fontSize={12} color="text.secondary">
                  Instant IMPS Transfer
                </Typography>
              </Paper>

              <Paper
                sx={{
                  mt: 3,
                  p: 2,
                  bgcolor: "#fff7ed",
                  borderRadius: 2,
                  fontSize: 13,
                  color: "#92400e",
                }}
              >
                Please verify the beneficiary details before proceeding. Bank
                transfers are irreversible once processed.
              </Paper>
            </Grid>

            {/* Right PIN Section */}
            <Grid size={{ xs: 12, md: 7 }} item xs={12} md={7}>
              <Paper sx={{ p: 4, borderRadius: 3, textAlign: "center" }}>
                <LockIcon sx={{ fontSize: 30, mb: 1 }} />
                <Typography fontWeight="bold">Enter Transaction PIN</Typography>
                <Typography fontSize={13} color="text.secondary" mb={3}>
                  Your 4-digit TPIN ensures secure payments
                </Typography>

                {/* PIN Dots */}
                <Box display="flex" justifyContent="center" gap={2} mb={3}>
                  {[0, 1, 2, 3].map((i) => (
                    <Box
                      key={i}
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        bgcolor: pin.length > i ? "#22c55e" : "#e5e7eb",
                      }}
                    />
                  ))}
                </Box>

                {/* Keypad */}
                <Grid container spacing={2} justifyContent="center">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                    <Grid size={{ xs: 4 }} item xs={4} key={n}>
                      <Button
                        fullWidth
                        sx={btnStyle}
                        onClick={() => handlePress(n)}
                      >
                        {n}
                      </Button>
                    </Grid>
                  ))}

                  <Grid size={{ xs: 4 }} item xs={4}></Grid>

                  <Grid item xs={4}>
                    <Button
                      fullWidth
                      sx={btnStyle}
                      onClick={() => handlePress(0)}
                    >
                      0
                    </Button>
                  </Grid>

                  <Grid size={{ xs: 4 }} item xs={4}>
                    <Button fullWidth sx={btnStyle} onClick={handleDelete}>
                      <BackspaceIcon />
                    </Button>
                  </Grid>
                </Grid>

                <Button
                  fullWidth
                  onClick={transactionstatus}
                  sx={{
                    mt: 4,
                    py: 1.6,
                    bgcolor: "#86efac",
                    color: "#14532d",
                    "&:hover": { bgcolor: "#4ade80" },
                  }}
                >
                  Confirm Payment ↗
                </Button>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}

const btnStyle = {
  height: 52,
  borderRadius: 2,
  bgcolor: "#f1f5f9",
  color: "#0f172a",
  fontSize: 18,
  "&:hover": { bgcolor: "#e2e8f0" },
};
